import React from 'react'
import Button from 'material-ui/Button'
import Download from 'material-ui-icons/CloudDownload'
import CircularProgress from 'material-ui/Progress/CircularProgress'
import green from 'material-ui/colors/green'
import { withStyles } from 'material-ui/styles'

const style = theme => ({
  wrapper: {
    margin: theme.spacing.unit,
    position: 'relative'
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '20px',
    left: '45%',
    marginTop: -12,
    marginLeft: -12
  }
})
const StockBalanceExport = ({ onDownloadFile, requestOngoing, classes }) => <div className={classes.wrapper}>
  <Button
    onClick={() => onDownloadFile()}
    variant='raised'
    disabled={requestOngoing}
  >
    <Download />
  Download Stock Balance
  </Button>
  {requestOngoing && <CircularProgress size={24} className={classes.buttonProgress} />}
</div>

export default withStyles(style)(StockBalanceExport)



// WEBPACK FOOTER //
// ./src/jobs/StockBalanceExport.js